import padEnd from 'lodash/padEnd'
import startCase from 'lodash/startCase'
import toLower from 'lodash/toLower'
import moment from 'moment/moment'
import numeral from 'numeral/numeral'

export const isIE = () => /* @cc_on!@ */!!document.documentMode

export const capitalizeString = (str) => {
  return startCase(toLower(str))
}

export const calculateHectare = (sizeInMeterSquared) => {
  const sizeInHectare = sizeInMeterSquared / 10000
  return parseFloat(Math.round(sizeInHectare * 100) / 100).toFixed(2)
}

export const formatArea = (area) => {
  if (area > 9999) {
    return formatNumber(area / 10000, 'ha')
  }

  return formatNumber(area, 'm²')
}

export const formatDate = (date, formatString = 'DD-MM-YYYY', defaultValue = '') => {
  if (!date) {
    return defaultValue
  }

  const parseDate = Date.parse(date)
  return moment(parseDate).format(formatString)
}

export const formatDecimal = (value, places = 2, separator = false, defaultValue = '-', roundingFunction = Math.round) => {
  if (!value) {
    return defaultValue
  }

  const numeralValue = numeral(value)
  let format
  if (separator) {
    format = numeralValue.format(padEnd('0,0.', 4 + places, '0'), roundingFunction)
  } else {
    format = numeralValue.format(padEnd('0.', 2 + places, '0'), roundingFunction)
  }

  return format
}

export const formatDistance = (number, defaultValue = '-') => {
  if (!number) {
    return defaultValue
  }

  return `${numeral(parseFloat(number)).format('0.00', Math.floor)} km`
}

export const formatNumber = (number, unit = '', defaultValue = '-') => {
  if (!number) {
    return defaultValue
  }

  return isDecimal(number)
    ? `${formatDecimal(number)}${unit}`
    : `${numeral(number).format('0,0')}${unit}`
}

export const formatPercentage = (value) => {
  if (!value) {
    return value
  }

  return numeral(value).format('0.0') + '%'
}

export const formatPrice = (number, symbol = '$', defaultValue = '') => {
  if (!number) {
    return defaultValue
  }

  return numeral(number).format(`${symbol}0,0`)
}

export const formatShortenPrice = (value, decimalPlaces = 2, roundingFunction = Math.floor, defaultValue = null) => {
  if (!value) {
    return defaultValue
  }

  const { price, unit } = shortenPrice(value)

  const formatInDecimalString = padEnd('0.', 2 + decimalPlaces, '0')
  const formatString = unit === 'M' && isDecimal(price) ? formatInDecimalString : '0'

  return numeral(price).format(`$${formatString}`, roundingFunction) + unit
}

export const getArea = (value) => {
  let area = '-'
  if (value) {
    area = value >= 10000 ? <span>{calculateHectare(value)}ha</span>
      : <span>{value}m<sup>2</sup></span>
  }
  return area
}

export const isDecimal = (value, defaultValue = false) => {
  if (!value) {
    return defaultValue
  }

  return (parseFloat(value) % 1) !== 0
}

export const replaceNbsps = (str) => {
  return str.replace(/\u00a0/g, ' ')
}

export const shortenPrice = (value) => {
  const K = 1000
  const M = 1000000

  let price
  let unit = ''
  if (value >= M) {
    price = value / M
    unit = 'M'
  } else {
    price = value / K
    unit = 'K'
  }

  return { price, unit }
}

export const delay = timeout =>
  new Promise(resolve => setTimeout(resolve, timeout))
